export class RouletteGridConfiguration {
    //******************************************************************************************************************
    //  Sizes used to generate table grid
    //******************************************************************************************************************

    public static gridWidth: number;
    public static gridHeight: number;
    public static zeroWidth: number;
    public static zeroHeight: number;
    public static numberWidth: number;
    public static numberHeight: number;
    public static columnWidth: number;
    public static columnHeight: number;
    public static dozenWidth: number;
    public static dozenHeight: number;
    public static pairedWidth: number;
    public static pairedHeight: number;

    //******************************************************************************************************************
    //  Grid bet sizes used in HTML Components
    //******************************************************************************************************************

    public static EdgeButtonWidth: number;
    public static EdgeButtonHeight: number;
    public static ChipOffsetY: number;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RouletteGridConfiguration.ts
 **/